import React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import MyButton from '../Button/MyButton';

const MyDialog = ({
  open,
  maxWidth = 'sm',
  dialogTitle = '',
  dialogContent = '',
  dialogActionsConfig = [],
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth={maxWidth}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>{dialogContent}</DialogContent>
      <DialogActions>
        {dialogActionsConfig.map(
          ({ id, label, color, onClick = () => {}, startIcon }) => (
            <MyButton
              key={id}
              startIcon={startIcon}
              onClick={onClick}
              color={color}
            >
              {label}
            </MyButton>
          ),
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MyDialog;
